// extracted by mini-css-extract-plugin
export default {"root":"CenterOnRobotButton_root__LIEsp","button":"CenterOnRobotButton_button__6UIBm","icon":"CenterOnRobotButton_icon__XqYR8"};